/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SafetyMessage
 */
export interface SafetyMessage {
    /**
     * 
     * @type {string}
     * @memberof SafetyMessage
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof SafetyMessage
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SafetyMessage
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof SafetyMessage
     */
    body: string;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyMessage
     */
    active: boolean;
}

/**
 * Check if a given object implements the SafetyMessage interface.
 */
export function instanceOfSafetyMessage(value: object): value is SafetyMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function SafetyMessageFromJSON(json: any): SafetyMessage {
    return SafetyMessageFromJSONTyped(json, false);
}

export function SafetyMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafetyMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'body': json['body'],
        'active': json['active'],
    };
}

export function SafetyMessageToJSON(json: any): SafetyMessage {
    return SafetyMessageToJSONTyped(json, false);
}

export function SafetyMessageToJSONTyped(value?: SafetyMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'body': value['body'],
        'active': value['active'],
    };
}

